import React, {ReactNode} from 'react';
import {Box, Divider, Stack} from "@mui/material"
import StatBlock from "./StatBlock"

export interface Stat {
    value: ReactNode
    label: string
}

function StatBar({stats}: {stats: Stat[]}) {
    return (
        <Box sx={{
            display: "inline-flex",
            border: 1,
            borderColor: "divider",
            borderRadius: 2,
            bgcolor: "background.paper",
            overflow: "hidden",
        }}>
            <Stack direction="row" divider={<Divider orientation="vertical" flexItem/>}>
                {stats.map(stat =>
                    <Box key={stat.label} sx={{px: 2, py: 1}}>
                        <StatBlock value={stat.value} label={stat.label}/>
                    </Box>,
                )}
            </Stack>
        </Box>
    )
}

export default StatBar;
